import { EventEmitter, inject, Injectable } from "@angular/core";
import { FirebaseAuthService } from "./firebase/firebase-auth.service";
import { MESSAGE } from "../../../../commondata/messages/msg-constants";
import {
  AuthenticationService,
  Credentials,
} from "./authentication/authentication.service";
import { Router } from "@angular/router";
import {
  BusyMessage,
  CredentialsMissingMessage,
  CredentialsResponseMessage,
  DirtyStateMessage,
  SaveStatusMessage,
  ShellMessage,
  UserLoggedOutMessage,
} from "../../../../commondata/messages/messages-dto";
import { UrlService } from "./url.service";
import { ModuleStateService } from "../module-state.service";
import { User } from "firebase/auth";
import { ThemeManagerService } from "../theme-manager.service";
import { Subscription } from "rxjs";
import { InitialStateDto, UserConfigOptionsDto } from "../../../../commondata/messages/initial-state-dto";
import { CustomSelectElement } from "../shared/custom-select-element-dto";
import { rehydrateSelectionDataDto, SelectionDataDto } from "../../../../commondata/messages/selection-data-dto";
import { TLInteractionDto } from "../../../../commondata/messages/tl-interaction-dto";
import { ImageDataDto } from "../../../../commondata/messages/image-data-dto";
import { MatomoTracker } from "ngx-matomo-client";

@Injectable({
  providedIn: "root",
})
export class ModuleMessageService {
  private firebaseAuthService = inject(FirebaseAuthService);
  private authenticationService = inject(AuthenticationService);
  private locationHistoryService = inject(UrlService);
  private moduleStateService = inject(ModuleStateService);
  private themeManagerService = inject(ThemeManagerService);
  private tracker = inject(MatomoTracker);
  private router = inject(Router);
  private moduleId = "";
  private landingUrl = "";

  private shellCredentials: any;
  private shellfbCredentials: any;
  private shelltoken: any;

  userInitialized = false;
  credentialmissing = false;
  public isAuthenticationChanged = new EventEmitter<Credentials>();
  public saveRequested = new EventEmitter();
  public changedName = new EventEmitter<string>();
  onDirtyStateChangeSubscription: Subscription | undefined;
  onSaveStatusChangeSubscription: Subscription | undefined;
  onBusyStateChangeSubscription: Subscription | undefined;
  logoutSubscription: Subscription | undefined;

  constructor() { }

  public initialize(
    moduleId: string,
    landingUrl: string,
    isLocked: boolean
  ) {
    this.moduleId = moduleId;
    this.landingUrl = landingUrl;
    this.moduleStateService.isLockedbyUser = isLocked;
    this.onDirtyStateChangeSubscription?.unsubscribe();
    this.onDirtyStateChangeSubscription = this.moduleStateService.onDirtyStateChange.subscribe((status: boolean) => {
      const msg = new DirtyStateMessage(this.moduleStateService.docId, status);
      this.sendMessage(msg);
    });
    this.onSaveStatusChangeSubscription?.unsubscribe();
    this.onSaveStatusChangeSubscription = this.moduleStateService.onSaveStatusChange.subscribe((status: number) => {
      const msg = new SaveStatusMessage(this.moduleStateService.docId, status);
      this.sendMessage(msg);
    });
    this.onBusyStateChangeSubscription?.unsubscribe();
    this.onBusyStateChangeSubscription = this.moduleStateService.onBusyStateChange.subscribe((status: boolean) => {
      const msg = new BusyMessage(this.moduleStateService.docId, status);
      this.sendMessage(msg);
    });
  }

  handleMessage(event: MessageEvent) {
    const eventData = event.data as unknown as ShellMessage;
    switch (eventData.msgType) {
      case MESSAGE.MSGTYPE.CREDENTIAL_RESPONSE:
        // Credenziali ricevute
        const msg = event.data as unknown as CredentialsResponseMessage;
        this.shellCredentials = msg.msgData.credentials;
        this.shellfbCredentials = msg.msgData.fbcredentials;
        this.shelltoken = msg.msgData.token;
        const cr = this.firebaseAuthService.getCurrentFirebaseUserEmail(); // this.firebaseAuthService.getFirebaseUser(); // this.authenticationService.credentials;
        const forcelogin = cr !== JSON.parse(this.shellCredentials).username; //this.shellCredentials;
        if (forcelogin) {
          this.authenticationService.setCredentials(
            JSON.parse(this.shellCredentials)
          );
        }
        this.reloadCredentials(forcelogin)
          .then((cred: User | null) => {
            this.authenticationService.reloadCredentials();
            localStorage.setItem("fbcredentials", this.shellfbCredentials);
            localStorage.setItem("token", this.shelltoken);
            if (cred?.displayName === "") {
              const msg = new CredentialsMissingMessage(
                this.moduleStateService.guid,
                { createCustomToken: true }
              );
              this.sendMessage(msg);
            } else {
              this.router.navigate([this.landingUrl], { replaceUrl: true });
            }
          })
          .catch((error) => {
            const msg = new CredentialsMissingMessage(this.moduleId, {
              createCustomToken: true,
            });
            (window as any).top.postMessage(msg, "*");
          });
        break;
      case MESSAGE.MSGTYPE.CREDENTIAL_CHANGED:
        const cred = eventData.msgData as Credentials;
        this.authenticationService.setCredentials(cred);
        this.isAuthenticationChanged.emit(cred);

        break;
      case MESSAGE.MSGTYPE.USER_LOGOUT:
        this.logoutSubscription?.unsubscribe();
        this.logoutSubscription = this.authenticationService.logout().subscribe(() => {
          const msglogout = new UserLoggedOutMessage(this.moduleId, {});
          this.sendMessage(msglogout);
        });
        break;
      case MESSAGE.MSGTYPE.NOTIFY_TARGET_DOC:
        // console.log('NOTIFY_TARGET_DOC: ' + JSON.stringify(eventData.msgData));
        this.moduleStateService.sideDocInfo = eventData.msgData;
        break;
      case MESSAGE.MSGTYPE.DOC_NAME_RESPONSE:
        this.moduleStateService.name = eventData.msgData.docName;
        this.changedName.emit(eventData.msgData.docName);
        break;
      case MESSAGE.MSGTYPE.SAVE_DOC_REQUEST:
        if (this.moduleStateService.docId === eventData.msgData.docId) {
          this.saveRequested.emit();
        }
        break;
      case MESSAGE.MSGTYPE.ENABLE_TTS:
        this.moduleStateService.ttsEnabled = eventData.msgData.ttsEnable;

        //MATOMO Pdf enable TTS
        if (this.moduleStateService.ttsEnabled) {
          try {
            console.log('MATOMO event Pdf enable TTS');
            this.tracker.trackEvent('Pdf', 'Enable TTS', 'EnableTTS');
          } catch (e: any) {
            console.error('matomo error ' + e.message);
          }
        }
        break;
      case MESSAGE.MSGTYPE.PRINT:
        this.moduleStateService.onPrint.emit(eventData.msgData.qrCode);

        //MATOMO Pdf Print pdf
        try {
          console.log('MATOMO event Pdf Print pdf');
          this.tracker.trackEvent('Pdf', 'Print Pdf', 'PrintPdf');
        } catch (e: any) {
          console.error('matomo error ' + e.message);
        }
        break;
      case MESSAGE.MSGTYPE.CENTER_MAP:
        this.moduleStateService.onOptimizeView.emit();
        break;
      case MESSAGE.MSGTYPE.ZOOM:
        if (eventData.msgData.zoom === 100) {
          this.moduleStateService.onOptimizeView.emit();
        } else {
          this.moduleStateService.onZoomChange.emit(eventData.msgData.zoom);
        }
        break;
      case MESSAGE.MSGTYPE.FIND_IN_DOC:
        this.moduleStateService.onToggleFindText.emit(eventData.msgData.activeFind);
        break;
      case MESSAGE.MSGTYPE.CONVERT_TO_IMAGE:
        const qrCodes = eventData.msgData.qrCode;
        this.moduleStateService.onDownload.emit();
        break;
      case MESSAGE.MSGTYPE.SET_INITIAL_STATE:
        const state = (eventData.msgData.state as InitialStateDto);
        this.themeManagerService.toggleTheme(eventData.msgData.state.theme);
        this.moduleStateService.ttsEnabled = state.enableTTS;
        this.moduleStateService.languages = this.convertLanguagesObjectToArray(state.languages);
        this.moduleStateService.voices = { ...state.voices };
        this.moduleStateService.isClaireEnabledInConfig.set((state.options as UserConfigOptionsDto)?.claireEnabledInConfig ?? false);
        this.moduleStateService.onSetInitialState.emit(state);
        break;
      case MESSAGE.MSGTYPE.ON_USER_PREFERENCE_CHANGED:
      const prefs = eventData.msgData as UserConfigOptionsDto;
      this.moduleStateService.isClaireEnabledInConfig.set(prefs?.claireEnabledInConfig ?? false);
      break;
      case MESSAGE.MSGTYPE.TALKING_START:
        this.moduleStateService.onTalkingStart.emit();
        break;
      case MESSAGE.MSGTYPE.TALKING_END:
        this.moduleStateService.onTalkingEnd.emit();
        break;
      case MESSAGE.MSGTYPE.MATH_CONTENT:
        this.moduleStateService.onMathContent.emit(eventData);

        //MATOMO Math insert formula in Pdf 
        try {
          console.log('MATOMO event Math insert formula in Pdf');
          this.tracker.trackEvent('Math', 'Insert formula in Pdf', 'InsertFormulaInPdf');
        } catch (e: any) {
          console.error('matomo error ' + e.message);
        }
        break;
      case MESSAGE.MSGTYPE.MATH_OPEN:
        this.moduleStateService.onMathOpen.emit(eventData.msgData);
        break;
      case MESSAGE.MSGTYPE.PLAY:
        this.moduleStateService.onStartPlay.emit();
        break;
      case MESSAGE.MSGTYPE.LANGUAGE_CHANGED:
        this.moduleStateService.onLanguageChangedFromShell.emit(eventData.msgData.language);
        break;
      case MESSAGE.MSGTYPE.SEARCH_SELECTION:
        this.moduleStateService.onSearchSelection.emit(eventData.msgData);
        break;
      case MESSAGE.MSGTYPE.COPY_SELECTION:
        this.moduleStateService.onCopySideSelection.emit();
        break;
      case MESSAGE.MSGTYPE.PASTE_SELECTION:
        const data: SelectionDataDto = rehydrateSelectionDataDto(eventData.msgData);
        data.fromGuid = eventData.fromGuid;
        this.moduleStateService.onPasteSideSelection.emit(data);
        break;
      case MESSAGE.MSGTYPE.SPEECH_RECOGNITION_TEXT:
        const text = eventData.msgData.text;
        this.moduleStateService.onSpeechRecognitionText.emit(text);
        break;
      case MESSAGE.MSGTYPE.IMAGE_INSERT:
        const imageData: ImageDataDto = eventData.msgData as ImageDataDto;
        this.moduleStateService.onImageInsert.emit(imageData);
        break;
      case MESSAGE.MSGTYPE.IMAGE_MAP_INSERT:
        const image: string = eventData.msgData;
        this.moduleStateService.onImageMapInsert.emit(image);
        break;
      case MESSAGE.MSGTYPE.REQUEST_CROP_IMAGE:
        this.moduleStateService.onRequestCrop.emit();
        break;
      case MESSAGE.MSGTYPE.TL_INTERACTION:
        const tlInteraction: TLInteractionDto = eventData.msgData;
        this.moduleStateService.onTLInteraction.emit(tlInteraction);
        break;
      default:
        break;
    }
  }

  convertLanguagesObjectToArray(languages: any): CustomSelectElement[] {
    const result: CustomSelectElement[] = [];
    const keys = Object.keys(languages);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const language = languages[key];
      result.push(
        {
          viewValue: language.viewValue,
          value: language.value,
          icon: language.icon,
          hidden: language.hidden,
          browserTTS: language.browserTTS
        }
      );
    }
    return result;
  }


  reloadCredentials(forcelogin: boolean): Promise<User | null> {
    // Ricarica credenziali
    return new Promise((resolve, reject) => {
      // const credentials = localStorage.getItem("credentials");
      const user = this.firebaseAuthService.currentUser;
      Promise.resolve()
        .then(() => {
          if (forcelogin && this.firebaseAuthService.currentUser !== null) {
            return this.firebaseAuthService.logoutPromise();
          } else {
            return Promise.resolve();
          }
        })
        .then(() => {
          const user = this.firebaseAuthService.currentUser;
          if (forcelogin || this.firebaseAuthService.currentUser === null) {
            const customToken =
              this.authenticationService?.credentials?.customToken || "";
            if (customToken) {
              return this.firebaseAuthService.signInCustomToken(customToken);
            } else {
              return this.firebaseAuthService.getCurrentFirebaseUser();
            }
          } else {
            return this.firebaseAuthService.getCurrentFirebaseUser();
          }
        })
        .then((cred: User | null) => {
          this.userInitialized = true;
          return resolve(cred);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  }

  public sendMessage(message: any) {
    (window as any).top.postMessage(message, "*");
  }
}
